import { useState, useEffect } from 'react';
import { getRefundAmount } from '../api/refundCalculator';

interface RefundAmountResponse {
  refund_amount: number;
}

export const useRefundAmount = (fallbackAmount: number) => {
  const [data, setData] = useState<RefundAmountResponse>({
    refund_amount: fallbackAmount,
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getRefundAmount();
        setData(result);
      } catch (error) {
        console.error('Failed to fetch refund amount:', error);
      }
    };

    fetchData();
  }, []);

  return data;
};

export default useRefundAmount;
